import Vue from 'vue'
import VueRouter from 'vue-router'
import i18n, { getLang } from '@/utils/lang'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: () => import('@/views/index/index'),
    name: 'Index',
    meta: {
      title: 'DD专车',
      key: 'home',
      keepAlive: true,
      content: { keywords: '首页', description: '首页' }
    }
  },
  {
    path: '/home',
    component: () => import('@/views/index/index'),
    name: 'Home',
    meta: {
      title: 'DD专车',
      key: 'home',
      keepAlive: true,
      content: { keywords: '首页', description: '首页' }
    }
  },
  {
    path: '/car-introduction',
    component: () => import('@/views/carIntroduction/index'),
    name: 'carIntroduction',
    meta: {
      title: '车种介绍',
      key: 'carIntroduction',
      content: { keywords: '车种介绍', description: '车种介绍' }
    }
  },
  {
    path: '/car-service',
    component: () => import('@/views/carService/index'),
    name: 'CarService',
    meta: {
      title: '用车服务',
      key: 'carService',
      content: { keywords: '用车服务', description: '用车服务' }
    }
  },
  {
    path: '/add-service',
    component: () => import('@/views/addService/index'),
    name: 'AddService',
    meta: {
      title: '附加服务',
      key: 'addService',
      content: { keywords: '附加服务', description: '附加服务' }
    }
  },
  {
    path: '/clubs-summary',
    component: () => import('@/views/clubsSummary/index'),
    name: 'ClubsSummary',
    meta: {
      title: '公司概要',
      key: 'clubsSummary',
      content: { keywords: '公司概要', description: '公司概要' }
    }
  },
  {
    path: '/contact-us',
    component: () => import('@/views/contactUs/index'),
    name: 'ContactUs',
    meta: {
      title: '联系我们',
      key: 'contactUs',
      content: { keywords: '联系我们', description: '联系我们' }
    }
  },
  {
    path: '/push-details',
    component: () => import('@/views/pushDetails/index'),
    name: 'PushDetails',
    meta: {
      title: '推送详情',
      key: 'pushDetails',
      content: { keywords: '推送详情', description: '推送详情' }
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      if (from.meta.keepAlive) {
        from.meta.savedPosition = document.body.scrollTop
      }
      return { x: 0, y: to.meta.savedPosition || 0 }
    }
  },
  routes
})

//处理路由标题国际化
const getPageTitle = (i18n, meta) => {
  // i18n.locale = 'zhf'
  let lang = getLang()
  i18n.locale = localStorage.getItem('language') || lang
  const hasKey = i18n.te(`routeTitle.${meta.key}`)
  const title = i18n.t(`routeTitle.${meta.key}`)
  if (hasKey) {
    return title
  }
  return meta.title
}

const getPageDescription = (i18n, meta) => {
  let lang = getLang()
  i18n.locale = localStorage.getItem('language') || lang
  const hasKey = i18n.te(`descTitle.${meta.key}`)
  const descTitle = i18n.t(`descTitle.${meta.key}`)
  if (hasKey) {
    return descTitle
  }
}

const getPageKeywords = (i18n, meta) => {
  let lang = getLang()
  i18n.locale = localStorage.getItem('language') || lang
  const hasKey = i18n.te(`keywordsTitle.${meta.key}`)
  const descTitle = i18n.t(`keywordsTitle.${meta.key}`)
  if (hasKey) {
    return descTitle
  }
}

// 获取原型对象上的push函数
const originalPush = VueRouter.prototype.push
// 修改原型对象中的push方法
VueRouter.prototype.push = function push(location) {
  if (location.split('?')[0] === window.location.pathname) {
    originalPush.call(this, location).catch(err => err)
    window.location.reload()
  } else {
    return originalPush.call(this, location).catch(err => err)
  }
}

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = getPageTitle(i18n, to.meta)
  }
  if (to.meta.content) {
    const head = document.getElementsByTagName('head')
    const meta = document.createElement('meta')
    document
      .querySelector('meta[name="keywords"]')
      .setAttribute('content', getPageKeywords(i18n, to.meta))
    document
      .querySelector('meta[name="description"]')
      .setAttribute('content', getPageDescription(i18n, to.meta))
    meta.content = to.meta.content
    head[0].appendChild(meta)
  }
  return next()
})

export default router
